var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutubeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Youtube",
    transform: "translate(-921 -688)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3149",
    "data-name": "Group 3149",
    transform: "translate(0 -23)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    transform: "translate(921 713.002)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dribbble-Light-Preview",
    transform: "translate(0 -0.002)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "youtube-_168_",
    "data-name": "youtube-[#168]",
    d: "M249.592,7288.711v-3.934c1.4.658,2.475,1.295,3.752,1.974-1.054.588-2.357,1.239-3.752,1.96m7.772-5.887a1.835,1.835,0,0,0-1.087-.645,76.354,76.354,0,0,0-10.569,0,1.854,1.854,0,0,0-.93.47c-1.128,1.05-.774,6.664-.5,7.573a2.03,2.03,0,0,0,.449.868,1.815,1.815,0,0,0,.945.49,66.777,66.777,0,0,0,10.586.035,1.864,1.864,0,0,0,.973-.5c1.043-1.043.972-6.972.136-8.288",
    transform: "translate(-244 -7281.997)",
    fill: "#949494",
    fillRule: "evenodd"
  })))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_982",
    "data-name": "Rectangle 982",
    width: 14,
    height: 14,
    transform: "translate(921 711)",
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeIcon);
export default __webpack_public_path__ + "static/media/youtube-icon.fd7a68220be7b8d9a70af2965cbae208.svg";
export { ForwardRef as ReactComponent };